(function () {
  var ROOT_SELECTOR = '.pack-bopo[data-pack-mode="bopo-bodys"]';
  var secondsCache = {};
  var secondsInflight = {};
  var GRID_IMAGE_WIDTH = 400;

  /** Shopify CDN: forzar width para thumbs del modal (menos peso / carga más pareja). */
  function sizedImageUrl(url, width) {
    var raw = String(url || "").trim();
    if (!raw) {
      return "";
    }
    var w = width || GRID_IMAGE_WIDTH;
    if (/([?&])width=\d+/i.test(raw)) {
      return raw.replace(/([?&])width=\d+/i, "$1width=" + w);
    }
    return raw + (raw.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
  }

  function productImageMarkup(src, alt) {
    var url = sizedImageUrl(src, GRID_IMAGE_WIDTH);
    if (!url) {
      return '<div class="pack-bopo__prod-ph">Sin imagen</div>';
    }
    return (
      '<img src="' +
      escapeHtml(url) +
      '" alt="' +
      escapeHtml(alt || "") +
      '" width="' +
      GRID_IMAGE_WIDTH +
      '" height="' +
      Math.round(GRID_IMAGE_WIDTH * 1.2) +
      '" decoding="async" loading="eager">'
    );
  }

  /** Evita que las fotos salgan columna a columna: revelar el grid cuando carguen. */
  function bindGridImages(root) {
    if (!root) {
      return;
    }
    var imgs = root.querySelectorAll(".pack-bopo__prod-img-wrap img");
    root.classList.remove("is-images-ready");
    if (root._bopoImgTimer) {
      clearTimeout(root._bopoImgTimer);
      root._bopoImgTimer = null;
    }
    if (!imgs.length) {
      root.classList.add("is-images-ready");
      return;
    }
    var pending = imgs.length;
    function done() {
      pending -= 1;
      if (pending <= 0) {
        root.classList.add("is-images-ready");
        if (root._bopoImgTimer) {
          clearTimeout(root._bopoImgTimer);
          root._bopoImgTimer = null;
        }
      }
    }
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.complete && img.naturalWidth > 0) {
        done();
        return;
      }
      img.addEventListener("load", done, { once: true });
      img.addEventListener("error", done, { once: true });
    });
    root._bopoImgTimer = setTimeout(function () {
      root.classList.add("is-images-ready");
      root._bopoImgTimer = null;
    }, 700);
  }

  function softMatch(a, b) {
    a = String(a == null ? "" : a);
    b = String(b == null ? "" : b);
    if (a === b) {
      return true;
    }
    a = a.toLowerCase().replace(/\s+/g, " ").trim();
    b = b.toLowerCase().replace(/\s+/g, " ").trim();
    if (a === b) {
      return true;
    }
    return a.replace(/\s+/g, "-") === b.replace(/\s+/g, "-");
  }

  function lookupSecond(map, value) {
    if (!map || !value) {
      return "";
    }
    if (map[value]) {
      return map[value];
    }
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i += 1) {
      if (softMatch(keys[i], value)) {
        return map[keys[i]];
      }
    }
    return "";
  }

  function buildSecondByColor(product) {
    var map = {};
    var colorIndex = typeof product.color_option_index === "number" ? product.color_option_index : 0;

    (product.variants || []).forEach(function (variant) {
      if (!variant.second_image) {
        return;
      }
      var colorValue = variant.options && variant.options[colorIndex];
      if (colorValue) {
        map[colorValue] = variant.second_image;
      }
    });

    if (product.second_by_color) {
      Object.keys(product.second_by_color).forEach(function (key) {
        map[key] = product.second_by_color[key];
      });
    }

    return map;
  }

  function mergeSecondsIntoProduct(product, payload) {
    if (!product || !payload) {
      return product;
    }

    product.color_option_index =
      typeof payload.color_option_index === "number" ? payload.color_option_index : product.color_option_index || 0;
    product.second_by_color = Object.assign({}, product.second_by_color || {}, payload.second_by_color || {});

    if (payload.variants && product.variants) {
      product.variants.forEach(function (variant) {
        var match = payload.variants.find(function (item) {
          return String(item.id) === String(variant.id);
        });
        if (match && match.second_image) {
          variant.second_image = match.second_image;
        }
      });
    }

    return product;
  }

  function detectColorOptionIndex(options) {
    if (!options || !options.length) {
      return 0;
    }

    for (var index = 0; index < options.length; index += 1) {
      var name = String(options[index].name || "").toLowerCase();
      if (name.indexOf("talla") !== -1 || name.indexOf("size") !== -1) {
        continue;
      }
      return index;
    }

    return 0;
  }

  function preloadSecondImages(map) {
    if (!map) {
      return;
    }

    Object.keys(map).forEach(function (key) {
      var url = map[key];
      if (!url) {
        return;
      }
      var img = new Image();
      img.decoding = "async";
      img.src = url;
    });
  }

  function fetchProductSeconds(product, section) {
    if (!product || !product.handle) {
      return Promise.resolve(product);
    }

    var cacheKey = String(product.id);
    if (secondsCache[cacheKey]) {
      return Promise.resolve(mergeSecondsIntoProduct(product, secondsCache[cacheKey]));
    }

    if (secondsInflight[cacheKey]) {
      return secondsInflight[cacheKey].then(function (payload) {
        return mergeSecondsIntoProduct(product, payload);
      });
    }

    var namespace = (section && section.dataset.metafieldNamespace) || "custom";
    var metafieldKey = (section && section.dataset.metafieldKey) || "custom_second_image";
    var secondsUrl =
      "/products/" +
      encodeURIComponent(product.handle) +
      "?view=pack-seconds&ns=" +
      encodeURIComponent(namespace) +
      "&key=" +
      encodeURIComponent(metafieldKey);

    secondsInflight[cacheKey] = fetch(secondsUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("No se pudieron cargar las segundas imagenes.");
        }
        return response.json();
      })
      .then(function (payload) {
        secondsCache[cacheKey] = payload;
        delete secondsInflight[cacheKey];
        if (payload && payload.second_by_color) {
          preloadSecondImages(payload.second_by_color);
        }
        return payload;
      })
      .catch(function () {
        delete secondsInflight[cacheKey];
        return null;
      });

    return secondsInflight[cacheKey].then(function (payload) {
      return payload ? mergeSecondsIntoProduct(product, payload) : product;
    });
  }

  function isProductInStock(product) {
    if (!product || !product.default_variant_id) {
      return false;
    }

    if (product.variants && product.variants.length > 1) {
      return product.variants.some(function (variant) {
        return variant.available;
      });
    }

    return Boolean(product.available);
  }

  function transformShopifyProduct(product) {
    var firstImage = product.images && product.images.length ? product.images[0].src : "";
    var variants = (product.variants || []).map(function (variant) {
      var optionValues = [variant.option1, variant.option2, variant.option3].filter(function (value) {
        return value !== null && value !== undefined && value !== "";
      });

      return {
        id: variant.id,
        title: variant.title,
        available: variant.available,
        image: variant.featured_image && variant.featured_image.src ? variant.featured_image.src : "",
        second_image: "",
        price: Math.round(parseFloat(variant.price || 0) * 100),
        options: optionValues
      };
    });

    var transformed = {
      id: product.id,
      handle: product.handle,
      name: product.title,
      img: firstImage,
      available: product.available,
      is_variable: variants.length > 1,
      color_option_index: detectColorOptionIndex(product.options || []),
      second_by_color: {},
      default_variant_id: variants[0] ? variants[0].id : null,
      variants: variants,
      options: (product.options || []).map(function (option) {
        return {
          name: option.name,
          values: option.values
        };
      })
    };

    return isProductInStock(transformed) ? transformed : null;
  }

  function fetchCollectionProducts(handle, limit) {
    var collected = [];
    var page = 1;

    function fetchPage() {
      var remaining = limit - collected.length;
      var requestLimit = remaining > 250 ? 250 : remaining;

      return fetch(
        "/collections/" + encodeURIComponent(handle) + "/products.json?limit=" + requestLimit + "&page=" + page
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error("No se pudieron cargar mas productos.");
          }
          return response.json();
        })
        .then(function (data) {
          if (!data.products || !data.products.length) {
            return collected;
          }

          data.products.forEach(function (product) {
            var transformed = transformShopifyProduct(product);
            if (transformed) {
              collected.push(transformed);
            }
          });

          if (collected.length >= limit || data.products.length < requestLimit) {
            return collected.slice(0, limit);
          }

          page += 1;
          return fetchPage();
        });
    }

    return fetchPage();
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function initPackBopo(section) {
    if (!section || section.dataset.initialized === "true" || section.dataset.empty === "true") {
      return;
    }

    section.dataset.initialized = "true";

    var productsNode = section.querySelector("[data-pack-products]");
    if (!productsNode) {
      return;
    }

    var messageNode = section.querySelector("[data-pack-message]");
    var duplicateAlert =
      section.dataset.duplicateAlert ||
      "Solo se puede escoger una unidad de la misma referencia. Escoge otra, por favor.";
    var allowDuplicates = section.dataset.allowDuplicates === "true";

    function showInitMessage(text) {
      if (!messageNode) {
        return;
      }
      messageNode.hidden = false;
      messageNode.textContent = text;
      messageNode.classList.add("pack-bopo__message--error");
    }

    var products = [];
    var productsLimit = Number(section.dataset.productsLimit || 50);
    var collectionHandle = section.dataset.collectionHandle || "";

    try {
      products = JSON.parse(productsNode.textContent).filter(function (product) {
        return isProductInStock(product);
      });
    } catch (error) {
      console.error("Pack BOPO Bodys: no se pudo leer el catalogo de productos.", error);
      showInitMessage("No se pudieron cargar los productos del pack. Recarga la pagina o revisa la seccion.");
      return;
    }

    function bootstrapPackUI() {
      products = products.filter(function (product) {
        return isProductInStock(product);
      });

      if (!products.length && productsLimit > 0) {
        showInitMessage("No hay productos disponibles en esta coleccion.");
      }

      var slotCount = Number(section.dataset.slotCount || 4);
      var cartUrl = section.dataset.cartUrl || "/cart/add.js";
      var checkoutUrl = section.dataset.checkoutUrl || "/checkout";
      var buyButton = section.querySelector("[data-pack-buy]");
      var resetButton = section.querySelector("[data-pack-reset]");
      var slots = Array.prototype.slice.call(section.querySelectorAll("[data-pack-slot]"));
      var area = section.querySelector("[data-pack-area]");
      var overlay = section.querySelector("[data-pack-overlay]");
      var productsPanel = section.querySelector("[data-products-grid]");
      var variantsPanel = section.querySelector("[data-variant-content]");
      var popupTitle = section.querySelector("[data-popup-title]");
      var backBtn = section.querySelector("[data-close-variants]");
      var closeBtn = section.querySelector("[data-close-products]");
      var paginationNode = section.querySelector("[data-pagination]");
      var codEnabled = section.dataset.codEnabled !== "false";
      var codCheckout = null;

      if (codEnabled && window.PackCodCheckout) {
        try {
          codCheckout = window.PackCodCheckout.create(section, {
            orderEndpoint: section.dataset.codEndpoint || "/apps/cod-express",
            checkoutEndpoint: "/apps/cod-express/checkout",
            checkoutFallback: "https://cod-express-r15e.onrender.com/checkout",
            collectionHandle: collectionHandle,
            // Flete fijo $26.000 (centavos Shopify) incluido en el total; oculto en UI.
            shippingFlat: 2600000,
            taxRatePercent: 0,
            disableTax: true,
            hideItemPrices: true,
            showNetSubtotal: true,
            concealShippingFee: true,
            pricingPaymentMethod: "cod",
            packKind: "bodys",
            packMode: "bopo-bodys",
            // Pague X lleve Y: no contar Purchase Meta (sí en otras landings).
            blockMetaPurchase: true,
            freeShippingThreshold: 0,
            currency: section.dataset.codCurrency || "COP",
            packLabel: section.dataset.codPackLabel || "Pack Bodys",
            submitLabel: section.dataset.codSubmitLabel || "Confirmar pedido COD",
            onlineSubmitLabel: section.dataset.codOnlineSubmitLabel || "Continuar al pago seguro",
            loadingLabel: section.dataset.codLoadingLabel || "Procesando...",
            onlineLoadingLabel: "Redirigiendo al checkout...",
            paymentNoteCod: section.dataset.codPaymentNote || "",
            paymentNoteOnline: section.dataset.codOnlinePaymentNote || "",
            enableOnlinePayment: section.dataset.codEnableOnline !== "false",
            showCheckoutFallback: section.dataset.codFallback !== "false",
            storefrontToken: section.dataset.codStorefrontToken || "",
            storefrontApiUrl: "/api/" + (section.dataset.codStorefrontApi || "2025-01") + "/graphql.json",
            cartUrl: cartUrl,
            checkoutUrl: checkoutUrl
          });
        } catch (error) {
          console.error("Pack BOPO Bodys: no se pudo iniciar checkout COD.", error);
        }
      }

      var currentState = {
        currentSlot: null,
        selected: {},
        currentPage: 1,
        perPage: 16,
        currentProduct: null,
        variantFilters: {},
        view: "products"
      };

      function showMessage(text, isError) {
        if (!messageNode) {
          return;
        }
        messageNode.hidden = !text;
        messageNode.textContent = text || "";
        messageNode.classList.toggle("pack-bopo__message--error", Boolean(text && isError));
        messageNode.classList.toggle("pack-bopo__message--success", Boolean(text && !isError));
      }

      function openArea() {
        if (!area) {
          return;
        }
        var popup = area.querySelector(".pack-bopo__popup");
        var overlayEl = area.querySelector(".pack-bopo__overlay");
        area.hidden = false;
        document.body.classList.add("pack-bopo-modal-open");
        // Reinicia la animación de entrada en cada apertura del slot.
        [overlayEl, popup].forEach(function (el) {
          if (!el) {
            return;
          }
          el.classList.remove("is-enter");
          void el.offsetWidth;
          el.classList.add("is-enter");
        });
      }

      function closeArea() {
        if (!area) {
          return;
        }
        var popup = area.querySelector(".pack-bopo__popup");
        var overlayEl = area.querySelector(".pack-bopo__overlay");
        if (popup) {
          popup.classList.remove("is-enter");
        }
        if (overlayEl) {
          overlayEl.classList.remove("is-enter");
        }
        area.hidden = true;
        document.body.classList.remove("pack-bopo-modal-open");
        showProductsView(false);
      }

      function showProductsView(animate) {
        currentState.view = "products";
        if (popupTitle) {
          popupTitle.textContent = section.dataset.popupTitle || "Escoge tu producto";
        }
        if (backBtn) {
          backBtn.hidden = true;
        }
        if (productsPanel) {
          productsPanel.hidden = false;
          productsPanel.classList.remove("is-leaving");
        }
        if (variantsPanel) {
          variantsPanel.hidden = true;
          variantsPanel.classList.remove("is-entering");
          if (!animate) {
            variantsPanel.innerHTML = "";
          }
        }
      }

      function showVariantsView() {
        currentState.view = "variants";
        if (popupTitle) {
          popupTitle.textContent = currentState.currentProduct
            ? currentState.currentProduct.name
            : section.dataset.popupTitle || "Escoge tu producto";
        }
        if (backBtn) {
          backBtn.hidden = false;
        }
        if (productsPanel) {
          productsPanel.classList.add("is-leaving");
          window.setTimeout(function () {
            productsPanel.hidden = true;
          }, 220);
        }
        if (variantsPanel) {
          variantsPanel.hidden = false;
          variantsPanel.classList.add("is-entering");
        }
      }

      function isSelectedProduct(product) {
        return Object.keys(currentState.selected).some(function (slot) {
          var entry = currentState.selected[slot];
          if (typeof entry === "object") {
            return entry.product_id === product.id;
          }
          return entry === product.default_variant_id;
        });
      }

      function renderProducts() {
        if (!productsPanel) {
          return;
        }

        if (!products.length) {
          productsPanel.innerHTML = '<p class="pack-bopo__empty">No hay productos disponibles en esta coleccion.</p>';
          if (paginationNode) {
            paginationNode.innerHTML = "";
          }
          return;
        }

        var start = (currentState.currentPage - 1) * currentState.perPage;
        var items = products.slice(start, start + currentState.perPage);

        productsPanel.innerHTML =
          items
            .map(function (product) {
              var selectedClass = isSelectedProduct(product) ? " pack-bopo__prod--selected" : "";
              return (
                '<button type="button" class="pack-bopo__prod' +
                selectedClass +
                '" data-product-id="' +
                product.id +
                '">' +
                '<div class="pack-bopo__prod-img-wrap">' +
                productImageMarkup(product.img, product.name) +
                "</div>" +
                '<span class="pack-bopo__prod-title">' +
                escapeHtml(product.name) +
                "</span></button>"
              );
            })
            .join("") +
          '<div class="pack-bopo__paging" data-pagination-inner></div>';

        var pagingInner = productsPanel.querySelector("[data-pagination-inner]");
        var totalPages = Math.max(1, Math.ceil(products.length / currentState.perPage));
        if (pagingInner) {
          pagingInner.innerHTML =
            '<button type="button" class="pack-bopo__page-btn" data-page="prev"' +
            (currentState.currentPage === 1 ? " disabled" : "") +
            ">Anterior</button>" +
            "<span>Pagina " +
            currentState.currentPage +
            " de " +
            totalPages +
            "</span>" +
            '<button type="button" class="pack-bopo__page-btn" data-page="next"' +
            (currentState.currentPage === totalPages ? " disabled" : "") +
            ">Siguiente</button>";
        }
        if (paginationNode) {
          paginationNode.innerHTML = "";
        }
        bindGridImages(productsPanel);
      }

      function fillSlot(slotNode, image, alt) {
        if (!slotNode) {
          return;
        }
        slotNode.innerHTML = image
          ? '<img class="pack-bopo__slot-img" src="' +
            escapeHtml(image) +
            '" alt="' +
            escapeHtml(alt || "Producto seleccionado") +
            '">'
          : "";
        slotNode.classList.toggle("pack-bopo__slot--filled", Boolean(image));
      }

      function syncPromoSlots() {
        if (!window.PromoCountdown) {
          return;
        }
        window.PromoCountdown.setSlotsFilled(Object.keys(currentState.selected).length);
      }

      function resetSelections() {
        currentState.selected = {};
        slots.forEach(function (slot) {
          fillSlot(slot, null);
        });
        showMessage("", false);
        if (window.PromoCountdown) {
          window.PromoCountdown.resetSlots();
        }
      }

      function openSlotPicker(slotNode) {
        currentState.currentSlot = slotNode;
        currentState.currentPage = 1;
        showProductsView(false);
        renderProducts();
        // Un frame con contenido montado evita el “salto” al primer paint.
        window.requestAnimationFrame(function () {
          openArea();
        });
      }

      function chooseSimpleProduct(product) {
        if (!product.default_variant_id) {
          showMessage("Este producto no tiene una variante disponible.", true);
          return;
        }
        if (!product.available) {
          showMessage("Este producto no esta disponible.", true);
          return;
        }
        if (!allowDuplicates && isSelectedProduct(product)) {
          showMessage(duplicateAlert, true);
          return;
        }

        var slotKey = currentState.currentSlot.dataset.slot;
        currentState.selected[slotKey] = product.default_variant_id;
        fillSlot(currentState.currentSlot, product.img, product.name);
        syncPromoSlots();
        closeArea();
        showMessage("", false);
      }

      function variantLabel(product, variant) {
        if (!variant) {
          return "";
        }
        if (product && product.options && product.options.length && variant.options) {
          return product.options
            .map(function (option, index) {
              var value = variant.options[index];
              if (!value || value === "Default Title") {
                return "";
              }
              return escapeHtml(option.name) + ": " + escapeHtml(value);
            })
            .filter(Boolean)
            .join(", ");
        }
        if (variant.title && variant.title !== "Default Title") {
          return escapeHtml(variant.title);
        }
        return "";
      }

      function variantImage(product, variant) {
        if (variant && variant.image) {
          return variant.image;
        }
        if (variant && variant.second_image) {
          return variant.second_image;
        }
        if (product) {
          var colorIndex = typeof product.color_option_index === "number" ? product.color_option_index : 0;
          var colorValue = variant && variant.options ? variant.options[colorIndex] : "";
          var mapped = lookupSecond(buildSecondByColor(product), colorValue);
          if (mapped) {
            return mapped;
          }
          return product.img || "";
        }
        return "";
      }

      function getFilteredVariants(product) {
        var filters = currentState.variantFilters || {};
        return (product.variants || []).filter(function (variant) {
          if (!variant.available) {
            return false;
          }
          return (product.options || []).every(function (option, index) {
            var filterValue = filters[index];
            if (!filterValue) {
              return true;
            }
            return variant.options && variant.options[index] === filterValue;
          });
        });
      }

      function renderVariantCards(product) {
        if (!variantsPanel) {
          return;
        }
        var list = variantsPanel.querySelector("[data-variant-list]");
        if (!list) {
          return;
        }

        var filtered = getFilteredVariants(product);
        if (!filtered.length) {
          list.innerHTML = '<p class="pack-bopo__empty">No hay variantes con ese filtro.</p>';
          return;
        }

        list.innerHTML = filtered
          .map(function (variant) {
            var img = variantImage(product, variant);
            var label = variantLabel(product, variant);
            return (
              '<button type="button" class="pack-bopo__prod pack-bopo__variant-card" data-variant-id="' +
              variant.id +
              '">' +
              '<div class="pack-bopo__prod-img-wrap">' +
              productImageMarkup(img, label || product.name) +
              "</div>" +
              '<span class="pack-bopo__prod-title">' +
              (label || escapeHtml(product.name)) +
              "</span></button>"
            );
          })
          .join("");
        bindGridImages(list);
      }

      function renderVariantPicker(product) {
        currentState.currentProduct = product;
        currentState.variantFilters = {};

        fetchProductSeconds(product, section).then(function (readyProduct) {
          currentState.currentProduct = readyProduct;

          var filterMarkup = (readyProduct.options || [])
            .map(function (option, index) {
              if (!option.values || option.values.length < 2) {
                return "";
              }
              var optionsHtml = option.values
                .map(function (value) {
                  return '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + "</option>";
                })
                .join("");
              return (
                '<label class="pack-bopo__filter">' +
                '<span class="pack-bopo__filter-label">Filtrar por ' +
                escapeHtml(option.name) +
                "</span>" +
                '<select class="pack-bopo__filter-select" data-filter-index="' +
                index +
                '">' +
                '<option value="">Todas</option>' +
                optionsHtml +
                "</select></label>"
              );
            })
            .filter(Boolean)
            .join("");

          variantsPanel.innerHTML =
            '<div class="pack-bopo__variant-grid-wrap">' +
            '<div class="pack-bopo__variant-list" data-variant-list></div>' +
            (filterMarkup
              ? '<div class="pack-bopo__filters" data-variant-filters>' + filterMarkup + "</div>"
              : "") +
            "</div>";

          renderVariantCards(readyProduct);
          showVariantsView();
        });
      }

      function chooseVariantById(variantId) {
        var product = currentState.currentProduct;
        if (!product) {
          return;
        }
        var variant = (product.variants || []).find(function (item) {
          return String(item.id) === String(variantId);
        });
        if (!variant) {
          showMessage("No existe esa combinacion.", true);
          return;
        }
        if (!variant.available) {
          showMessage("La variante seleccionada no esta disponible.", true);
          return;
        }
        if (!allowDuplicates && isSelectedProduct(product)) {
          showMessage(duplicateAlert, true);
          return;
        }

        var slotKey = currentState.currentSlot.dataset.slot;
        currentState.selected[slotKey] = {
          product_id: product.id,
          variant_id: variant.id
        };
        fillSlot(currentState.currentSlot, variantImage(product, variant), product.name);
        syncPromoSlots();
        closeArea();
        showMessage("", false);
      }

      function validateSelection() {
        var ids = Object.keys(currentState.selected)
          .sort(function (a, b) {
            return Number(a) - Number(b);
          })
          .map(function (key) {
            return currentState.selected[key];
          });

        if (ids.length !== slotCount) {
          showMessage("Debes seleccionar " + slotCount + " productos.", true);
          return null;
        }

        return ids.map(function (entry) {
          return {
            id: typeof entry === "object" ? entry.variant_id : entry,
            quantity: 1
          };
        });
      }

      function addPackToCart() {
        var items = validateSelection();
        if (!items) {
          return;
        }

        if (codCheckout) {
          codCheckout.open(items, products, {
            onComplete: function () {
              resetSelections();
              showMessage("Pedido registrado correctamente.", false);
            }
          });
          return;
        }

        buyButton.disabled = true;
        buyButton.textContent = section.dataset.buttonLoadingText || "Procesando...";
        showMessage("", false);

        fetch(cartUrl + ".js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("No se pudo agregar el pack al carrito.");
            }
            return response.json();
          })
          .then(function () {
            window.location.href = checkoutUrl;
          })
          .catch(function (error) {
            showMessage(error.message, true);
          })
          .finally(function () {
            buyButton.disabled = false;
            buyButton.textContent = section.dataset.buttonDefaultText || "Comprar ahora";
          });
      }

      slots.forEach(function (slot) {
        slot.addEventListener("click", function () {
          openSlotPicker(slot);
        });
      });

      if (overlay) {
        overlay.addEventListener("click", closeArea);
      }
      if (closeBtn) {
        closeBtn.addEventListener("click", closeArea);
      }
      if (backBtn) {
        backBtn.addEventListener("click", function () {
          showProductsView(true);
          renderProducts();
        });
      }

      if (productsPanel) {
        productsPanel.addEventListener("click", function (event) {
          var pageButton = event.target.closest("[data-page]");
          if (pageButton) {
            var totalPages = Math.max(1, Math.ceil(products.length / currentState.perPage));
            if (pageButton.dataset.page === "next" && currentState.currentPage < totalPages) {
              currentState.currentPage += 1;
            }
            if (pageButton.dataset.page === "prev" && currentState.currentPage > 1) {
              currentState.currentPage -= 1;
            }
            renderProducts();
            return;
          }

          var productButton = event.target.closest(".pack-bopo__prod");
          if (!productButton) {
            return;
          }

          var product = products.find(function (item) {
            return String(item.id) === productButton.dataset.productId;
          });
          if (!product) {
            return;
          }

          if (product.is_variable) {
            renderVariantPicker(product);
          } else {
            chooseSimpleProduct(product);
          }
        });
      }

      if (variantsPanel) {
        variantsPanel.addEventListener("click", function (event) {
          var card = event.target.closest("[data-variant-id]");
          if (card) {
            chooseVariantById(card.dataset.variantId);
          }
        });

        variantsPanel.addEventListener("change", function (event) {
          var select = event.target.closest("[data-filter-index]");
          if (!select || !currentState.currentProduct) {
            return;
          }
          var index = Number(select.dataset.filterIndex);
          currentState.variantFilters = currentState.variantFilters || {};
          currentState.variantFilters[index] = select.value || "";
          renderVariantCards(currentState.currentProduct);
        });
      }

      if (resetButton) {
        resetButton.addEventListener("click", resetSelections);
      }
      if (buyButton) {
        buyButton.addEventListener("click", addPackToCart);
      }

      window.PackCheckout = window.PackCheckout || {};
      window.PackCheckout.triggerBuy = function () {
        if (buyButton) {
          buyButton.click();
        }
      };

      function getAvailableSizes() {
        var sizes = [];
        var seen = {};

        products.forEach(function (product) {
          if (!product.options || !product.options.length) {
            return;
          }

          product.options.forEach(function (option, optionIndex) {
            var optionName = String(option.name || "").toLowerCase();
            if (optionName.indexOf("talla") === -1 && optionName.indexOf("size") === -1) {
              return;
            }

            (option.values || []).forEach(function (value) {
              if (!value || seen[value]) {
                return;
              }

              var hasAvailable = (product.variants || []).some(function (variant) {
                return variant.available && variant.options && variant.options[optionIndex] === value;
              });

              if (hasAvailable) {
                seen[value] = true;
                sizes.push(value);
              }
            });
          });
        });

        return sizes;
      }

      function fillSelections(selections) {
        resetSelections();

        (selections || []).forEach(function (selection) {
          var slotNode = slots[selection.slotIndex];
          if (!slotNode) {
            return;
          }

          var slotKey = slotNode.dataset.slot;
          var product =
            products.find(function (item) {
              return selection.productId && String(item.id) === String(selection.productId);
            }) || null;
          var variant =
            product &&
            (product.variants || []).find(function (item) {
              return String(item.id) === String(selection.variantId);
            });

          if (selection.productId) {
            currentState.selected[slotKey] = {
              product_id: selection.productId,
              variant_id: selection.variantId
            };
          } else {
            currentState.selected[slotKey] = selection.variantId;
          }

          fillSlot(slotNode, selection.image, selection.name);
        });

        syncPromoSlots();
        showMessage("", false);
      }

      if (window.PackPage && typeof window.PackPage.registerPackBuilder === "function") {
        window.PackPage.registerPackBuilder(section.dataset.sectionId, {
          packMode: "bopo-bodys",
          packSection: section,
          getProducts: function () {
            return products;
          },
          getSlotCount: function () {
            return slotCount;
          },
          getAvailableSizes: getAvailableSizes,
          fillSelections: fillSelections
        });
      }
    }

    if (collectionHandle && productsLimit > products.length) {
      fetchCollectionProducts(collectionHandle, productsLimit)
        .then(function (fetchedProducts) {
          if (fetchedProducts.length) {
            products = fetchedProducts.filter(function (product) {
              return isProductInStock(product);
            });
          }
          bootstrapPackUI();
        })
        .catch(function (error) {
          console.error("Pack BOPO Bodys: error cargando productos extra.", error);
          bootstrapPackUI();
        });
      return;
    }

    bootstrapPackUI();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initPackBopo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector(ROOT_SELECTOR);
    if (root) {
      root.dataset.initialized = "false";
      initPackBopo(root);
    }
  });
})();
